// =============================================
// SERVICIO DE CUENTAS BANCARIAS
// Maneja las peticiones al API de cuentas bancarias
// =============================================

import api from './api';

const bankAccountService = {
    // Obtener todas las cuentas bancarias (Admin)
    getAll: async (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.year) params.append('year', filters.year);
        if (filters.is_active !== undefined) params.append('is_active', filters.is_active);

        const response = await api.get(`/bank-accounts?${params.toString()}`);
        return response.data;
    },

    // Obtener solo cuentas activas (Propietarios)
    getActive: async () => {
        const response = await api.get('/bank-accounts/active');
        return response.data;
    },

    // Obtener cuenta por ID
    getById: async (id) => {
        const response = await api.get(`/bank-accounts/${id}`);
        return response.data;
    },

    // Crear nueva cuenta
    create: async (accountData) => {
        const response = await api.post('/bank-accounts', accountData);
        return response.data;
    },

    // Actualizar cuenta
    update: async (id, accountData) => {
        const response = await api.put(`/bank-accounts/${id}`, accountData);
        return response.data;
    },

    // Eliminar cuenta (soft delete)
    delete: async (id) => {
        const response = await api.delete(`/bank-accounts/${id}`);
        return response.data;
    },

    // Obtener lista de bancos
    deleteFIAccount: async (id) => {
        const response = await api.delete(`/bank-accounts/FI/${id}`);
        return response.data;
    },

    // =================================
    // CUENTA PROPIA (OWNER PORTAL)
    // =================================

    getMyAccount: async () => {
        const response = await api.get('/owner-bank-accounts/my-account');
        return response.data;
    },

    saveMyAccount: async (data) => {
        const response = await api.post('/owner-bank-accounts/my-account', data);
        return response.data;
    },

    // Obtener lista de bancos
    getBanks: async () => {
        const response = await api.get('/banks');
        return response.data;
    },
};

export default bankAccountService;
